import GameMetricsGraphComponent from './GameMetricsGraphComponent';

export default GameMetricsGraphComponent;
